// extracted by mini-css-extract-plugin
module.exports = {"panel":"NewToken_panel__3BGVk","tokenWrapper":"NewToken_tokenWrapper__3f-4t","token":"NewToken_token__3SYsc","dragging":"NewToken_dragging__jMWyn"};